import { connect } from 'react-redux';
import Admission from '../../views/Admission/Admission.admission.view';

export default connect(null, null)(Admission);
